import { render, staticRenderFns } from "./Sprachenauswahl.vue?vue&type=template&id=6cba024a&"
import script from "./Sprachenauswahl.vue?vue&type=script&lang=js&"
export * from "./Sprachenauswahl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports